<template>
  <div class="col-md-12">
    <SearchCard
      :filterCatch="true"
      :hasFilter="true"
      :title="title"
      :url="url"
      ref="searchCard"
      @updatePermissions="updatePermissions"
      @getOther="getOtherData"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col cols="12" class="py-1 mb-3 border-bottom">
          <b-row>
            <b-col cols="12" md="" class="py-1">
              <strong class="fs_1rem">
                {{
                  `${pathOr("", ["exercise", "name"], item)} - ${
                    $lang.parvandeh_number_in_kanoon
                  }: ${pathOr("", ["id"], item)}`
                }}
              </strong>
            </b-col>
            <b-col
              cols="12"
              md="auto"
              class="text-right py-1"
              :class="
                pathOr(0, ['not_confirmed_competency'], item)
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <strong v-text="$lang.not_confirmed_competency" />:
              <span v-text="pathOr(0, ['not_confirmed_competency'], item)" />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="4">
          <b-row>
            <b-col cols="12" md="5" class="text-center">
              <b-img-lazy
                fluid
                thumbnail
                :onerror="$config.images.onerrorDefaultImg"
                :src="getAvatar(item, 'candidate')"
                class="bg-white personal_image object__fit--cover"
              />
            </b-col>
            <b-col cols="12" md="7" class="px-md-0">
              <b-row>
                <b-col cols="12" md="12" class="py-1">
                  <b-img-lazy
                    fluid
                    :src="$config.images.shared.candidate"
                    v-b-tooltip
                    :title="$lang.candidate"
                    width="35"
                  />
                  <ProfileBoxPopupWrapper
                    v-if="
                      pathOr(false, ['candidate', 'person', 'full_name'], item)
                    "
                    :data="item.candidate"
                    deskTopPopupClass="top-230"
                    nameClass="color-complementary"
                  />
                  <span v-else class="text-muted" v-text="'******'" />
                </b-col>
                <b-col cols="12" md="12" class="py-1">
                  <i class="far fa-check-circle mr-1" />
                  <strong v-text="$lang.code" />:
                  <span
                    class="text-muted"
                    v-text="
                      pathOr(
                        null,
                        ['candidate', 'person_center_execute_code'],
                        item
                      )
                    "
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="4">
          <b-row>
            <b-col cols="12" md="5" class="text-center">
              <b-img-lazy
                fluid
                thumbnail
                :onerror="$config.images.onerrorDefaultImg"
                :src="getAvatar(item, 'assessor')"
                class="bg-white personal_image object__fit--cover"
              />
            </b-col>
            <b-col cols="12" md="7" class="px-md-0">
              <b-row>
                <b-col cols="12" md="12" class="py-1 d-flex align-items-center">
                  <b-img-lazy
                    fluid
                    :src="$config.images.shared.assessor"
                    width="35"
                    v-b-tooltip
                    :title="$lang.assessor"
                    class="mr-1"
                  />
                  <span>
                    <ProfileBoxPopupWrapper
                      v-if="
                        pathOr(false, ['assessor', 'person', 'full_name'], item)
                      "
                      :data="item.assessor"
                      deskTopPopupClass="top-230"
                      nameClass="color-complementary"
                    />
                    <span v-else class="text-muted" v-text="'******'" />
                    <b-button
                      v-if="!pathOr(false, ['is_absent'], item) && isAcManager"
                      variant="outline-success"
                      size="sm"
                      class="ml-2"
                      v-b-tooltip.hover
                      :title="$lang.change_assessor"
                      @click="getAssessorOptions(item)"
                    >
                      <mdicon name="account-edit-outline" size="20" />
                    </b-button>
                  </span>
                </b-col>
                <b-col cols="12" md="12" class="py-1">
                  <i class="far fa-check-circle mr-1" />
                  <strong v-text="$lang.code" />:
                  <span
                    class="text-muted"
                    v-text="
                      pathOr(
                        null,
                        ['assessor', 'person_center_execute_code'],
                        item
                      )
                    "
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="item.second_assessor" cols="12" md="4">
          <b-row>
            <b-col cols="12" md="5" class="text-center">
              <b-img-lazy
                fluid
                thumbnail
                :onerror="$config.images.onerrorDefaultImg"
                :src="getAvatar(item, 'second_assessor')"
                class="bg-white personal_image object__fit--cover"
              />
            </b-col>
            <b-col cols="12" md="7" class="px-md-0">
              <b-row>
                <b-col cols="12" md="12" class="py-1 d-flex align-items-center">
                  <b-img-lazy
                    fluid
                    :src="$config.images.shared.assessor"
                    width="35"
                    v-b-tooltip
                    :title="$lang.secondAssessor"
                    class="mr-1"
                  />
                  <ProfileBoxPopupWrapper
                    v-if="
                      pathOr(
                        false,
                        ['second_assessor', 'person', 'full_name'],
                        item
                      )
                    "
                    :data="item.second_assessor"
                    deskTopPopupClass="top-230"
                    nameClass="color-complementary"
                  />
                  <span v-else class="text-muted" v-text="'******'" />
                  <b-button
                    v-if="!pathOr(false, ['is_absent'], item) && isAcManager"
                    variant="outline-success"
                    size="sm"
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="$lang.change_second_assessor"
                    @click="getAssessorOptions(item, 'second_assessor')"
                  >
                    <mdicon name="account-edit-outline" size="20" />
                  </b-button>
                </b-col>
                <b-col cols="12" md="12" class="py-1">
                  <i class="far fa-check-circle mr-1" />
                  <strong v-text="$lang.code" />:
                  <span
                    class="text-muted"
                    v-text="
                      pathOr(
                        null,
                        ['second_assessor', 'person_center_execute_code'],
                        item
                      )
                    "
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center py-1 mt-3"
          v-if="idAllParvandeh"
        >
          <mdicon
            name="check-circle-outline"
            size="20"
            class="mr-1 mdi-flip-h"
          />
          <strong v-text="$lang.center_execute_name" />:&nbsp;
          <span
            class="text-muted"
            v-text="pathOr('', ['center_execute', 'name'], item)"
          />
        </b-col>
        <b-col cols="12" md="12" class="mt-3">
          <b-row>
            <b-col
              cols="12"
              md="auto"
              class="d-flex align-items-center py-1"
              v-if="item.start_time"
            >
              <mdicon name="timer-outline" size="20" class="mr-1 mdi-flip-h" />
              <strong v-text="$lang.start_time" />:&nbsp;
              <span
                class="text-muted"
                v-text="pathOr('', ['start_time'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              md="auto"
              class="d-flex align-items-center py-1"
              v-if="item.send_time"
            >
              <mdicon
                name="timer-off-outline"
                size="20"
                class="mr-1 mdi-flip-h"
              />
              <strong v-text="$lang.send_time_to" />:&nbsp;
              <span
                class="text-muted"
                v-text="pathOr('', ['send_time'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              md="auto"
              class="d-flex align-items-center py-1"
              v-if="item.delay_send_minutes"
            >
              <mdicon name="timer-sand" size="20" class="mr-1" />
              <strong v-text="$lang.delay_time" />:&nbsp;
              <span
                class="text-muted"
                v-text="
                  `${pathOr(0, ['delay_send_minutes'], item)} ${$lang.minute}`
                "
              />
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="d-flex align-items-center py-1"
              v-if="item.room_name"
            >
              <mdicon name="home-group" size="20" class="mr-1" />
              <span
                class="text-muted"
                v-text="pathOr('', ['room_name'], item)"
              />
            </b-col>
            <b-col
              v-if="!pathOr(false, ['is_absent'], item)"
              cols="12"
              md=""
              class="text-right d-flex align-items-center justify-content-end py-1"
            >
              <mdicon
                v-if="pathOr(false, ['has_evidence_error'], item)"
                class="text-danger mr-2 pulse_danger rounded-circle border-0 d-flex align-items-center justify-content-center height_20 width_20"
                name="information"
                size="25"
              />
              <b-button
                v-if="checkCandidateAbsentButton(item)"
                size="sm"
                variant="outline-warning"
                class="mr-2"
                @click="showCandidateAbsentConfirm(item)"
              >
                <mdicon name="account-remove-outline" size="20" class="mr-1" />
                <span v-text="$lang.set_absent" />
              </b-button>
              <b-button
                v-if="checkSetAbsentButton(item)"
                size="sm"
                variant="outline-danger"
                class="mr-2"
                @click="showAbsentConfirm(item)"
              >
                <mdicon name="account-cancel-outline" size="20" class="mr-1" />
                <span v-text="$lang.not_register_in_parvandeh" />
              </b-button>
              <span
                v-if="pathOr(null, ['status', 'id'], item)"
                class="text-center p-2 fs_12 rounded cursor_pointer hover_opacity font-weight-bold"
                :class="`bg__color--${pathOr(null, ['status', 'id'], item)}`"
                v-text="pathOr('', ['status', 'caption'], item)"
                v-b-tooltip.hover
                :title="generateLastUpdateTooltip(item)"
                @click="searchCompetency(item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <div
          class="absent__user text-danger"
          v-if="pathOr(false, ['is_absent'], item)"
          v-text="$lang.not_register_in_parvandeh"
        />
      </template>
    </SearchCard>
    <b-modal
      :title="$lang.search.columns_setting"
      variant="primary"
      hide-header
      content-class="border-primary"
      size="xl"
      v-model="calendarModal"
      :ok-title="$lang.submitButton"
    >
      <DragTable
        :url="center_execute_plan_url"
        :title="$lang.execute_plan"
        ref="center_execute_plan"
        :keyLang="`center_execute_plan`"
        :hasMoving="false"
        :editRoute="false"
        :removeLabel="$lang.exercise_remove"
        :outparams="center_execute_plan_params"
      />
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="calendarModal = false">
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
    <Confirm
      :title="modalTitle"
      :description="message"
      v-model="confirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="ok"
      @cancel="cancel"
    />
    <Confirm
      v-model="absentConfirmData.show"
      :title="absentConfirmData.title"
      :description="absentConfirmData.description"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      :loading="absentConfirmData.loading"
      :loadingSpinnerText="$lang.updating_data"
      dynamicClass=""
      @ok="setAbsent"
      @cancel="absentConfirmData.show = false"
    />
    <b-modal
      no-close-on-backdrop
      v-model="changeAssessorModal"
      size="sm"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          <b v-text="changeAssessorModalTitle" />
        </div>
        <LoadingSpinner
          :loading="changeAssessorLoading"
          :text="changeAssessorLoadingText"
        />
        <b-row v-show="!changeAssessorLoading">
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.assessor}: `"
                :rules="$v.assessorSelected.$params"
              />
              <selectFind
                :options="assessorOptions"
                v-model="$v.assessorSelected.$model"
                label="text"
                id="value"
                :isValid="
                  $v.assessorSelected.$dirty
                    ? !$v.assessorSelected.$error
                    : null
                "
              />
              <b-form-invalid-feedback
                :state="
                  $v.assessorSelected.$dirty
                    ? !$v.assessorSelected.$error
                    : null
                "
              >
                <div v-if="!$v.assessorSelected.required">
                  {{ $lang.error_required | replace($lang.assessor) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="text-right">
            <b-button
              class="mr-2"
              variant="outline-danger"
              @click="changeAssessorModal = false"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
            <b-button variant="success" @click="changeAssessor">
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <Confirm
      :title="candidateAbsentConfirmData.title"
      :description="candidateAbsentConfirmData.description"
      :loading="candidateAbsentConfirmData.loading"
      v-model="candidateAbsentConfirmData.show"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      dynamicClass=""
      @cancel="closeCandidateAbsentConfirm"
      @ok="setCandidateAbsent"
    >
      <template slot="extra-area">
        <b-form-group
          :label="$lang.absent_description"
          label-for="absent_description"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.absent_description"
            :rules="$v.absent_description.$params"
          />
          <b-form-textarea
            v-model="$v.absent_description.$model"
            :placeholder="$lang.absent_description"
            :rows="3"
            :state="
              $v.absent_description.$dirty
                ? !$v.absent_description.$error
                : null
            "
          >
          </b-form-textarea>
          <b-form-invalid-feedback id="absent_description-feedback"
            >{{ $lang.error_required | replace($lang.absent_description) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
    </Confirm>
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import Confirm from "@/components/base/confirm";
import DragTable from "@/components/base/dragTable";
import SearchCard from "@/components/base/searchCard";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl, goToRoute } from "@/shared/utils";

export default {
  components: {
    Confirm,
    DragTable,
    SearchCard,
    LoadingSpinner,
    ProfileBoxPopupWrapper,
  },
  validations: {
    assessorSelected: { required },
    absent_description: { required },
  },
  data() {
    return {
      hiddenFields: ["candidate.name"],
      modalTitle: "",
      message: "",
      confirmModal: false,
      calendarModal: false,
      changingItem: null,
      loadingItem: false,
      buttons: [
        {
          id: 0,
          name: "searchCompetencies",
          iconFont: "fas fa-folder-open fa-lg text-info ",
          click: this.searchCompetency,
          status_not: [],
        },
        {
          id: 11,
          name: "calendar",
          iconFont: "fa fa-list-ol fa-lg text-warning ",
          click: this.centerExecuteCalendar,
          status_not: [],
        },
      ],
      center_execute_plan_url: null,
      center_execute_plan_params: null,
      permissions: [],
      setAbsentLoading: false,
      otherData: null,
      absentConfirmData: {
        loading: false,
        show: false,
        item: null,
        title: this.$lang.not_register_in_parvandeh,
        description: `با ثبت عدم حضور در تمرین برای این شرکت کننده این پرونده از فرایند ثبت نمره حذف شده و در کارنامه نهایی با عنوان عدم حضور در تمرین بیان می شود
        <br>
        <br>
          <strong>با توجه به در نظر گرفتن تمام نکات گفته شده از ثبت عدم حضور در این تمرین برای این شرکت کننده مطمئن هستید؟</strong>
        `,
      },
      changeAssessorModal: false,
      changeAssessorModalTitle: "",
      changeAssessorLoading: false,
      changeAssessorLoadingText: this.$lang.receiving_data,
      assessorSelected: null,
      caseId: null,
      assessorOptions: [],
      absent_description: null,
      candidateAbsentConfirmData: {
        loading: false,
        show: false,
        id: null,
        centerExecuteId: null,
        title: this.$lang.set_absent,
        description: `<p>با ثبت غیبت برای این شرکت کننده کلیه پرونده های او در این کانون حذف می شود و این عمل غیر قابل برگشت خواهد بود. لطفا فقط زمانی غیبت برای شرکت کننده ثبت نمائید که مطمئن هستید شرکت کننده در کانون و هیچ کدام از تمرین ها حضور نخواهد داشت.</p><strong>آیا برای ثبت غیبت مطمئن هستید؟</strong>`,
      },
    };
  },
  computed: {
    url() {
      const id = this.$route.params.center_execute_id;
      return this.$route.name === "all_center_execute_case"
        ? generateApiUrl(["kanoon", "all_center_execute_case"])
        : generateApiUrl(["kanoon", "center_execute_case"], [id]);
    },
    title() {
      const acCaption = pathOr("", ["center_execute", "name"], this.otherData);
      return `${this.$lang.searchCenter_execute_case} ${acCaption}`;
    },
    isAcManager() {
      const userExecutiveRoleId = pathOr(
        null,
        ["executive_role", "id"],
        this.otherData
      );
      return includes(userExecutiveRoleId, [null, 3]);
    },
    idAllParvandeh() {
      return this.$route.name === "all_center_execute_case";
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    goToRoute,
    centerExecuteCalendar(item) {
      this.center_execute_plan_params = {
        id: this.$route.params.center_execute_id,
        center_execute_candidate_id: [
          item.candidate && item.candidate.person_center_execute_code,
        ],
        center_execute_assessor_id: [
          item.assessor && item.assessor.person_center_execute_code,
        ],
      };

      this.center_execute_plan_url =
        this.$config.api_url + this.$config.kanoon.center_execute_plan;
      this.calendarModal = true;
    },
    clearModal() {
      this.modalTitle = "";
      this.confirmModal = false;
    },
    ok() {
      this.confirmedChangeStatus();
      this.clearModal();
    },
    cancel() {
      this.notConfirmedChangeStatus();
      this.clearModal();
    },
    availableButtons(item) {
      if (!item || !("status_object" in item)) return [];

      return this.buttons.filter((x) => {
        return !x.status_not.includes(item.status_object.id);
      });
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    searchCompetency(item) {
      const name = "markCenterExecuteCaseCompetency";
      const params = {
        center_execute_id: pathOr(null, ["center_execute", "id"], item),
        case_id: pathOr(null, ["id"], item),
      };

      goToRoute(name, params, {}, false);
    },
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    confirmedChangeStatus() {
      this.loadingItem = true;
      let payLoad = {
        status: this.status,
      };
      return this.$httpService
        .patch(
          this.$config.api_url +
            this.$config.kanoon.center_execute_case.replace(
              "{0}",
              this.$route.params.center_execute_id
            ) +
            "/" +
            this.changingItem.id +
            "/status",
          payLoad
        )
        .then((response) => {
          this.$notify.success(response.data.message);
          this.$refs.search_center_execute_case.getItems();
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        })
        .finally(() => {
          this.loadingItem = true;
          this.status = null;
          this.changingItem = null;
          this.message = "";
          this.$refs.search_center_execute_case.getItems();
        });
    },
    notConfirmedChangeStatus() {
      this.removingItem = null;
      this.message = "";
    },
    changeStatus(item, status) {
      this.status = status;
      this.changingItem = item;
      this.message = this.$lang.are_you_sure;
      this.modalTitle = this.$lang.change_status;
      this.confirmModal = true;
    },
    getFullName(item) {
      const name = pathOr("", ["person", "name"], item);
      const family = pathOr("", ["person", "family"], item);
      return `${name} ${family}`;
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    getAvatar(item, key) {
      return pathOr(this.$config.images.tinyLogo, [key, "person", "img"], item);
    },
    getOtherData(data) {
      this.otherData = data;
    },
    checkSetAbsentButton(item) {
      const isAbsent = pathOr(false, ["is_absent"], item);
      const executiveRoleObj =
        this.$route.name === "all_center_execute_case" ? item : this.otherData;
      const userExecutiveRoleId = pathOr(
        null,
        ["executive_role", "id"],
        executiveRoleObj
      );
      const caseStatusId = pathOr(null, ["status", "id"], item);
      return (
        !isAbsent &&
        isAdmin(this.permissions, ["admin", "edit"]) &&
        includes(userExecutiveRoleId, [3, null]) &&
        includes(caseStatusId, [1])
      );
    },
    checkCandidateAbsentButton(item) {
      const executiveRoleObj =
        this.$route.name === "all_center_execute_case" ? item : this.otherData;
      const userExecutiveRoleId = pathOr(
        null,
        ["executive_role", "id"],
        executiveRoleObj
      );
      const caseStatusId = pathOr(null, ["status", "id"], item);
      return (
        isAdmin(this.permissions, ["admin", "edit"]) &&
        includes(userExecutiveRoleId, [3, null]) &&
        includes(caseStatusId, [1])
      );
    },
    showAbsentConfirm(item) {
      this.absentConfirmData.show = true;
      this.absentConfirmData.item = item;
    },
    async setAbsent() {
      try {
        this.absentConfirmData.loading = true;
        const id = pathOr(null, ["id"], this.absentConfirmData.item);
        const centerExecuteId = pathOr(
          null,
          ["center_execute", "id"],
          this.absentConfirmData.item
        );
        const url = generateApiUrl(
          ["kanoon", "parvandeh_set_absent"],
          [centerExecuteId, id]
        );
        const response = await this.$httpService.patch(url);
        this.$notify.success(response.data.message);
        this.$refs.searchCard.getItems();
        this.absentConfirmData.show = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.absentConfirmData.loading = false;
      }
    },
    async getAssessorOptions(item, type = "assessor") {
      try {
        this.changeAssessorModalTitle =
          type === "assessor"
            ? this.$lang.change_assessor
            : this.$lang.change_second_assessor;
        this.caseId = pathOr(null, ["id"], item);
        const code = pathOr(
          null,
          ["assessor", "person_center_execute_code"],
          item
        );
        const centerExecuteId = pathOr(null, ["center_execute", "id"], item);
        this.changeAssessorModal = true;
        this.changeAssessorLoadingText = this.$lang.receiving_data;
        this.changeAssessorLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_assessor"],
          [centerExecuteId],
          { "except_assessor_code[]": code }
        );
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.assessorOptions = data.map((item) => {
          return {
            text: `${pathOr(
              "",
              ["parvandeh", "parvandeh_number"],
              item
            )} - ${pathOr("", ["parvandeh", "person", "name"], item)} ${pathOr(
              "",
              ["parvandeh", "person", "family"],
              item
            )}`,
            value: pathOr(null, ["parvandeh", "code"], item),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.changeAssessorLoading = false;
      }
    },
    async changeAssessor() {
      try {
        this.changeAssessorModal = true;
        this.changeAssessorLoadingText = this.$lang.sending_data;
        this.changeAssessorLoading = true;
        const url = generateApiUrl(
          ["kanoon", "change_assessor"],
          [this.caseId]
        );
        const parvandeh_code = pathOr(null, ["value"], this.assessorSelected);
        const payload = { parvandeh_code };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.changeAssessorModal = false;
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.changeAssessorLoading = false;
      }
    },
    getItems() {
      this.$refs.searchCard.getItems();
    },
    showCandidateAbsentConfirm(item) {
      this.candidateAbsentConfirmData.id = pathOr(
        null,
        ["candidate", "id"],
        item
      );
      this.candidateAbsentConfirmData.centerExecuteId = pathOr(
        null,
        ["center_execute", "id"],
        item
      );
      this.candidateAbsentConfirmData.show = true;
    },
    closeCandidateAbsentConfirm(item) {
      this.absent_description = null;
      this.candidateAbsentConfirmData.id = null;
      this.candidateAbsentConfirmData.show = false;
    },
    async setCandidateAbsent() {
      this.$v.absent_description.$touch();
      if (this.$v.absent_description.$anyError) return;

      try {
        this.candidateAbsentConfirmData.loading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_absent"],
          [
            this.candidateAbsentConfirmData.centerExecuteId,
            this.candidateAbsentConfirmData.id,
          ]
        );
        const payload = {
          is_absent: 1,
          absent_description: this.absent_description,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeCandidateAbsentConfirm();
        this.$refs.searchCard.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.candidateAbsentConfirmData.loading = false;
      }
    },
    generateLastUpdateTooltip(item) {
      const lastUpdateTime = pathOr(
        "",
        ["status", "last_update", "jalali"],
        item
      );
      return `${this.$lang.changeTime} ${lastUpdateTime}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.bg__color {
  &--1 {
    background-color: #5bd4ff;
  }
  &--2 {
    background-color: #0170c2;
  }
  &--3 {
    background-color: #32ed3a;
  }
  &--4 {
    background-color: #00af50;
  }
  &--5 {
    background-color: #20a8d8;
  }
  &--6 {
    background-color: #20a8d8;
  }
  &--7 {
    background-color: #ffe59a;
  }
  &--8 {
    background-color: #bf8f00;
  }
}
</style>
